import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, AlertController, LoadingController, Platform } from '@ionic/angular';
import { APIService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { StorageService } from 'src/app/services/storage.service';
import { ObserverService } from 'src/app/services/observer.service';
import { GiftVoucherService } from '../../services/gift-voucher.service';
import { OrderService } from '../../services/order.service';
import { PersonService } from '../../services/person.service';
import { OrganisationService } from '../../services/organisation.service';
import { StarPRNT } from '@awesome-cordova-plugins/star-prnt/ngx';
import { Decimal } from "decimal.js";
import { StripeTerminalReaderService } from 'src/app/services/stripe-terminal-reader.service';
import { DateTimePickerPage } from './../../modals/date-time-picker/date-time-picker.page';
import { ConnectedAccountService } from '../../services/connected-account.service';
import * as Sentry from "@sentry/angular";
import { SmartpayReaderService } from 'src/app/services/smartpay-reader.service';
import { CartService } from 'src/app/services/cart.service';
import { CustomPaymentServiceService } from "src/app/services/custom-payment-service.service";
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-order-payment-add',
    templateUrl: './order-payment-add.page.html',
    styleUrls: ['./order-payment-add.page.scss']
})

export class OrderPaymentAddPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    order = null;
    gift_vouchers = null;
    xero_connected = false;
    moment = moment;
    stripe_terminal_connected = false;
    smartpay_connected = false;
    receipt_printer = null;
    receipt_printers = null;
    formatted_date = null;
    date_modal_css_class = '';
    gift_voucher_id = null;
    gift_voucher_code = null;
    person_store_credit = null;
    organisation_store_credit = null;
    custom_payment_services = [];
    settings = null;

    params: any = {
        method: 'cash',
        date: null,
        send_order_payment_receipt_email: false,
        add_xero_invoice_payment: false,
        price: 0,
        payment_service_transaction_id: undefined,
        payment_service_id: undefined
    };

    // modal flags
    date_picker_modal_open = false;

    surcharge_enabled = false;
    surchargable_method = false;
    surcharge_rate = null;
    price_without_surcharge = 0;
    surcharge_price = 0;

    constructor(
        private modalController: ModalController,
        private alertController: AlertController,
        private loadingController: LoadingController,
        private navParams: NavParams,
        private apiService: APIService,
        private authService: AuthService,
        private storageService: StorageService,
        private readerService: StripeTerminalReaderService,
        private observerService: ObserverService,
        private router: Router,
        private starprnt: StarPRNT,
        private platform: Platform,
        private giftVoucherService: GiftVoucherService,
        private orderService: OrderService,
        private personService: PersonService,
        private organisationService: OrganisationService,
        private connectedAccountService: ConnectedAccountService,
        private smartpayReaderService: SmartpayReaderService,
        private cartService: CartService,
        private customPaymentServiceService: CustomPaymentServiceService
    ) { }

    recalculateSurcharge(new_price:number) {

        const currency = this.order.currency;

        if(!this.surchargable_method) {
            // ensure 2dp
            this.params.price = Number(new Decimal(new_price).toDecimalPlaces(2));
            this.surcharge_price = 0;
            if(this.params.method === 'credit_card') {
                this.observerService.publish('stripe_terminal_add_payment_price_changed',{payment_price: this.params.price, surcharge_price: this.surcharge_price, currency});
            }
            else {
                this.observerService.publish('stripe_terminal_payment_closed', null);
            }
            return;
        }

        if (new_price > this.order.amount_due) {
            new_price = this.order.amount_due;
            this.price_without_surcharge = new_price;
        }

        if (this.surcharge_enabled && this.surcharge_rate && this.surcharge_rate > 0) {
            try {
                this.surcharge_price = Number(new Decimal(new_price).times(new Decimal(this.surcharge_rate).dividedBy(100)).toDecimalPlaces(2));
                this.params.price = Number(new Decimal(new_price).add(new Decimal(this.surcharge_price)).toDecimalPlaces(2));
            }
            catch(e) {
                // If error, invalid number
                // decimal.js recommended way to check for DecimalError
                if (e instanceof Error && /DecimalError/.test(e.message)) {
                    // So disable option to add payment
                    this.surcharge_price = 0;
                    this.params.price = null;
                }
            }
        } 
        else {
            // ensure 2dp
            this.params.price = Number(new Decimal(new_price).toDecimalPlaces(2));
            this.surcharge_price = 0;
        }
        
        if(this.params.method === 'credit_card') {
            this.observerService.publish('stripe_terminal_add_payment_price_changed',{payment_price: this.params.price, surcharge_price: this.surcharge_price, currency});
        }
        else {
            this.observerService.publish('stripe_terminal_payment_closed', null);
        }
    }

    ngOnInit() {

        this.cartService.get().then((cart) => {
            if(cart) {
                this.storageService.get('order_credit_card_surcharge_rate').then((credit_card_surcharge_rate) => {
                    if(credit_card_surcharge_rate && credit_card_surcharge_rate > 0) {
                        this.surcharge_enabled = true;
                        this.surcharge_rate = Number(credit_card_surcharge_rate); // TODO: why is this Number()?
                    }
                    this.order = this.navParams.get('order');
                    this.price_without_surcharge = this.order.total_price;
                    if(this.order.payments) {
                        for(let i = 0; i < this.order.payments.length; i++) {
                            this.price_without_surcharge = Number(new Decimal(this.price_without_surcharge).minus(this.order.payments[i].price).toDecimalPlaces(2));
                        }
                    }
                    this.recalculateSurcharge(this.price_without_surcharge);    
                });
            }
        });

        if(Capacitor.isNativePlatform()) {
            this.date_modal_css_class = 'backdrop';
        }

        if(this.navParams.get('order')) {

            this.order = this.navParams.get('order');
            this.params.price = this.order.total_price;

            if(this.order.payments) {
                for(let i = 0; i < this.order.payments.length; i++) {
                    this.params.price = Number(new Decimal(this.params.price).minus(this.order.payments[i].price).toDecimalPlaces(2));
                }
            }

            if(this.order.person || this.order.organisation) {

                if(this.order.person) {

                    this.params.send_order_payment_receipt_email = true;

                    let gift_voucher_params = {
                        is_paid: true,
                        is_expired: false,
                        has_remaining_balance: true,
                        person_id: this.order.person.id,
                        currency_id: this.order.currency.id
                    };

                    this.giftVoucherService.getGiftVouchers(gift_voucher_params).then((gift_vouchers: any) => {
                        if(gift_vouchers && gift_vouchers.length != 0) {
                            this.gift_vouchers = gift_vouchers;
                        }
                    })
                    .catch(() => { });
                
                }

                if(this.order.organisation) {
                    this.organisationService.getOrganisationStoreCredit(this.order.organisation.id, this.order.currency.id).then((store_credit: any) => {
                        if(store_credit) {
                            this.organisation_store_credit = store_credit;
                        }
                    })
                    .catch(() => { });
                }
                else if(this.order.person) {
                    this.personService.getPersonStoreCredit(this.order.person.id, this.order.currency.id).then((store_credit: any) => {
                        if(store_credit) {
                            this.person_store_credit = store_credit;
                        }
                    })
                    .catch(() => { });
                }
            }

            this.customPaymentServiceService.getCustomPaymentServices().then((custom_payment_services:[]) => {
                if(custom_payment_services) {
                    this.custom_payment_services = custom_payment_services;
                }
            })
            
            this.params.date = this.moment().toISOString(true);
            this.formatted_date = this.moment(this.params['date']).format("D MMM YYYY, HH:mm");

            this.loadData().then(() => {}).catch(() => { });

        }

        this.storageService.get("stripe_terminal_reader").then(reader => {
			if(reader) {
                this.stripe_terminal_connected = true;
                this.params.method = 'credit_card';
                this.methodChanged();
            }
		});

        this.storageService.get("smartpay_reader").then(reader => {
			if(reader) {
                this.smartpay_connected = true;
                this.params.method = 'credit_card';
                this.methodChanged();
            }
		});

        fetch('./assets/receipt-printers.json').then(response => response.json()).then(json => {
            this.receipt_printers = json;
        })
        .catch(() => {})

        this.platform.ready().then(() => {
            if(Capacitor.isNativePlatform()) {
                this.storageService.get("receipt_printer").then((receipt_printer) => {
                    if(receipt_printer) {
                        this.receipt_printer = receipt_printer;
                    }
                });
            }
        });

        this.observerService.subscribe("custom_payment_services_changed|order_payment_add_modal", custom_payment_services => {
            if(custom_payment_services) {
                this.custom_payment_services = custom_payment_services;
            }
        })

        this.observerService.subscribe("custom_payment_service_added|order_payment_add_modal", custom_payment_service => {
            if(custom_payment_service) {
                this.custom_payment_services.push(custom_payment_service);
            }
        })

        this.observerService.subscribe("custom_payment_service_deleted|order_payment_add_modal", custom_payment_service_id => {
            if(custom_payment_service_id) {
                for(let i = 0; i < this.custom_payment_services.length; i++) {
                    if(this.custom_payment_services[i].id == custom_payment_service_id) {
                        this.custom_payment_services.splice(i, 1);
                        break;
                    }
                }
            }
        })

        this.observerService.subscribe("custom_payment_service_updated|order_payment_add_modal", custom_payment_service => {
            if(custom_payment_service) {
                for(let i = 0; i < this.custom_payment_services.length; i++) {
                    if(this.custom_payment_services[i].id == custom_payment_service['id']) {
                        this.custom_payment_services[i] = custom_payment_service;
                        break;
                    }
                }
            }
        })

        this.observerService.subscribe('network_status_changed|order_payment_add_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Problem", "Offline", "You must be online to add a payment, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("custom_payment_services_changed|order_payment_add_modal");
        this.observerService.destroy("custom_payment_service_added|order_payment_add_modal");
        this.observerService.destroy("custom_payment_service_deleted|order_payment_add_modal");
        this.observerService.destroy("custom_payment_service_updated|order_payment_add_modal");
        this.observerService.destroy("network_status_changed|order_payment_add_modal");
    }

    loadData() {
        let promise = new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading settings").then(() => {
                this.loadSettings().then(() => {
                    if(this.settings.xero_connected == "true") {
                        this.xero_connected = true;
                    }
                    if(this.xero_connected && this.order.xero_invoice_id) {
                        this.params.add_xero_invoice_payment = true;
                    }
                    this.loading_spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
        return promise;
    }

    methodChanged() {

        this.surchargable_method = false;

        if(this.params.method == 'external_card') {
            this.surchargable_method = true;
        }

        if(this.params.method == 'credit_card' && this.stripe_terminal_connected) {
            this.surchargable_method = true;
        }

        this.recalculateSurcharge(this.price_without_surcharge);
    
        if(this.params.method == 'cash') {
            if(this.receipt_printer) {
                let port = this.receipt_printer['port'];
                let emulation = '';
                for(let i = 0; i < this.receipt_printers.length; i++) {
                    if(this.receipt_printers[i].model == this.receipt_printer['model']) {
                        emulation = this.receipt_printers[i].emulation;
                        break;
                    }
                }
                this.starprnt.openCashDrawer(port, emulation).catch((error: any) => {
                    this.presentAlert("Problem", "Unable to open cash drawer", "Please check your printer settings");
                });
            }
        }

        if(this.params.method != 'gift_voucher') {

            if(this.gift_voucher_id != undefined) {
                delete this.gift_voucher_id;
            }

            if(this.gift_voucher_code != undefined) {
                delete this.gift_voucher_code;
            }

        }

        if(this.params.method != 'custom') {

            if(this.params.payment_service_id != undefined) {
                this.params.payment_service_id = undefined;
            }

            if(this.params.payment_service_transaction_id != undefined) {
                this.params.payment_service_transaction_id = undefined;
            }

        }

    }

    close() {
        this.observerService.publish('stripe_terminal_payment_closed', null);
        this.modalController.dismiss();
    }

    async add() {

        let validated = true;

        if(isNaN(this.params.price) || this.params.price === null) {
            validated = false;
            this.presentAlert('Problem', 'Invalid amount', 'Please ensure the amount is a valid number.');
        }

        if(this.params['date'] == null || this.params['date'].trim() === "") {
            validated = false;
            this.presentAlert("Problem", "Missing date", "Please select a date.");
        }

        if(this.params.method == "gift_voucher") {

            if(!this.gift_voucher_id && !this.gift_voucher_code) {
                validated = false;
                this.presentAlert("Problem", "Missing gift voucher", "Please select a gift voucher.");
            }
            else if(!this.gift_voucher_id) {

                if(this.gift_voucher_code == null || this.gift_voucher_code.trim() === "") {
                    validated = false;
                    this.presentAlert("Problem", "Missing gift voucher code", "Please enter a gift voucher code.");
                }
                else {
                    
                    await this.giftVoucherService.getGiftVoucher(this.gift_voucher_code, {}).then((gift_voucher: any) => {
                        if(gift_voucher) {
                            this.params['gift_voucher_id'] = gift_voucher.id;
                        }
                    })
                    .catch((error: any) => {
                        validated = false;
                        this.presentAlert("Problem", "Invalid gift voucher code", "We couldn't find a valid gift voucher with that code.");
                    });

                }

            }
            else {
                this.params['gift_voucher_id'] = this.gift_voucher_id;
            }

        }

        if(this.params.method == "custom") {

            if(!this.params.payment_service_id) {
                validated = false;
                this.presentAlert("Problem", "Missing payment service", "Please select a payment service.");
            }

        }

        if(validated) {
            this.params.date = this.moment(this.params.date).utc().toISOString();
            this.addPayment();
        }

    }

    async addPayment() {

        // ensure 2dp
        const payment_price = Number(new Decimal(this.params.price).toDecimalPlaces(2));

        if(this.surcharge_enabled && this.surcharge_price > 0) {
            this.params.surcharge_rate = this.surcharge_rate;
        }

        if(this.params.method === 'credit_card') {
            if(this.stripe_terminal_connected) {
                const is_available = await this.readerService.checkAvailable();
                if(!is_available) {
                    this.presentAlert("Problem", "Card reader disconnected", "Card reader might have been hot-swapped. Please reconnect");
                    this.close();
                    return;
                }
                const charge_loading = this.loadingController.create({ message: 'Awaiting payment', backdropDismiss: true });
                charge_loading.then(loaded => {
                    loaded.onDidDismiss().then(event => {
                        if(event.role === 'backdrop') {
                            this.readerService.cancelCharge();
                        }
                    });
                    loaded.present();
                });
                this.readerService.charge(payment_price, this.order.currency.code.toLowerCase()).then(charge_res => {
                    charge_loading.then(l => l.dismiss());
                    if("error" in charge_res) {
                        const { code: error_code, message: error_message } = charge_res.error;
                        if(error_code === "canceled") {
                            //No alert, continue
                        }
                        else if(error_code === "network_timeout") {
                            this.presentAlert("Problem", "Network timeout", "Card reader timed out. Please check your connection.");
                            this.close();
                        }
                        else if(error_code === "reader_error") {
                            if(error_message === "The POS is no longer authenticated.") {
                                this.presentAlert("Problem", "Card reader disconnected", "Card reader might have been hot-swapped. Please reconnect");
                                this.close();
                            }
                            else {
                                this.presentAlert("Problem", "Card reader disconnected", "Cannot communicate with your card reader. Please check your connection.");
                                this.close();
                            }
                        }
                        else {
                            this.presentAlert("Problem", "Reading card failed", "Failed to read card. Please try again.");
                            this.readerService.refreshCart();
                        }
                        return;
                    }
                    const process_loading = this.loadingController.create({ message: "Processing payment" });
                    process_loading.then(l => l.present());
                    this.readerService.processPayment(charge_res.paymentIntent).then(async (process_res: { error: any } | { paymentIntent: any }) => {
                        process_loading.then(l => l.dismiss());
                        let payment_successful = true;
                        if("error" in process_res) {
                            payment_successful = false;          
                            const { type: error_type, code: error_code, decline_code } = process_res.error;
                            if(error_type === "card_error") {
                                if(error_code === "card_declined") {
                                    if(decline_code === "incorrect_pin") {
                                        this.presentAlert("Problem", "Card declined", "Incorrect PIN. Please try again.");
                                    }
                                    else {
                                        this.presentAlert("Problem", "Card declined", "Stripe decline code: " + decline_code);
                                    }
                                }
                            }
                            else if(error_type === "invalid_request_error") {
                                Sentry.captureMessage('Stripe invalid request error');
                                this.presentAlert("Problem", "Request failed", "Please contact Airsquare support.");
                            }
                            else if(error_type === "api_error") {
                                Sentry.captureMessage('Stripe API error');
                                this.presentAlert("Problem", "Request failed", "Stripe may be down. Please try again soon.");
                            }
                            else {
                                // Stripe failed to return status of payment, we explicity ask Stripe whether it succeeded                
                                Sentry.captureMessage('Stripe unknown error', {
                                    extra: {
                                        stripe_error: process_res['error'],
                                        stripe_payment_intent: charge_res['paymentIntent']
                                    }
                                });  
                                await this.apiService
                                    .getStripePaymentIntent(charge_res.paymentIntent.id)
                                    .then(payment_intent => {
                                        if(payment_intent.status === "succeeded") {
                                            payment_successful = true;
                                            process_res['paymentIntent'] = payment_intent;
                                        }
                                        else {
                                            this.presentAlert("Problem", "Processing payment failed", "Payment was not successful.");
                                        }
                                    })
                                    .catch((error) => {
                                        Sentry.captureException(error, {
                                            extra: {
                                                stripe_error: process_res['error'],
                                                stripe_payment_intent: charge_res['paymentIntent']
                                            }
                                        });
                                        this.presentAlert("Problem", "Processing payment failed", "Unable to retrieve status of payment.");
                                    });
                            }

                        }

                        if(payment_successful) {  
                            const transaction_id = process_res['paymentIntent'].charges.data[0].id;
                            this.params.payment_service_transaction_id = transaction_id;
                            this.params.payment_service_id = "BE5C31BF-FC83-9865-A57A1554B936A970"; // stripe

                            this.presentSpinner('Adding payment').then(() => {
                                this.orderService.addOrderPayment(this.order.id, this.params).then(async () => {
                                    await this.spinner.dismiss();
                                    await this.modalController.dismiss();
                                })
                                .catch(() => {
                                    this.spinner.dismiss();
                                });
                            });
                        }
                        else {
                            this.readerService.refreshCart();
                        }

                    })
                    .catch(e => {
                        this.readerService.refreshCart();
                        process_loading.then(l => l.dismiss());
                    });
                })
                .catch(e => {
                    this.readerService.refreshCart();
                    charge_loading.then(l => l.dismiss());
                });
            }
            else if(this.smartpay_connected) {

                this.loadingController.create({ message: 'Awaiting payment'}).then((loading) => {
                    let current_transaction_id:string;

                    let subscription = this.smartpayReaderService.transactionObservable.subscribe(payment_status => {
                        if (payment_status.transaction_id == current_transaction_id) {
                            if (payment_status.status == "success") {
                                this.params.price = payment_status.payment.price;
                                this.params.payment_service_transaction_id = payment_status.payment.payment_service_transaction_id;
                                this.params.payment_service_receipt_text = payment_status.payment.payment_service_receipt_text;
                                this.params.payment_service_id = "37CF49B6-9D0E-A6BE-BF18B291CAB60B65"; // smartpay
                                this.params.label = payment_status.payment.label;
                                this.params.method = payment_status.payment.method;
                                if("surcharge_rate" in payment_status.payment) {
                                    this.params.surcharge_rate = payment_status.payment.surcharge_rate;
                                }
                                this.presentSpinner('Adding payment').then(() => {
                                    this.orderService.addOrderPayment(this.order.id, this.params).then(async () => {
                                        await this.spinner.dismiss();
                                        await this.modalController.dismiss();
                                    })
                                    .catch(() => {
                                        this.spinner.dismiss();
                                    });
                                });
                            } else if(payment_status.status == "declined") {
                                this.presentAlert("Problem", "", "Payment declined");
                            } else if(payment_status.status == "failed") {
                                this.presentAlert("Problem", "", "Failed to charge card");
                            } else if(payment_status.status == "offline") {
                                this.presentAlert("Problem", "", "Smartpay reader is offline");
                            } else if(payment_status.status == "cancelled") {
                                this.presentAlert("Problem", "", "Payment cancelled");
                            } else if(payment_status.status == "service_unavailable") {
                                this.presentAlert("Problem", "", "Service unavailable");
                            } 
                            // TODO: Handle DELAYED??
                            if(payment_status.status != "delayed") {
                                loading.dismiss();
                                subscription.unsubscribe();
                            }
                        }
                    });
                    loading.present();
                    const price_cents = Number(new Decimal(this.params.price).times(100).toDecimalPlaces(0));
                    this.smartpayReaderService.chargeCard(price_cents).then((transaction_id) => {
                        current_transaction_id = transaction_id;
                    }).catch(error => {
                        loading.dismiss();
                        if(error == "unpaired") {
                            this.presentAlert("Problem", "", "The POS has been unpaired from the Smartpay reader. Cannot process payment");
                            this.smartpay_connected = false;
                            this.params.method = "cash";
                        } else if(error == "reader_busy") {
                            this.presentAlert("Problem", "", "The Smartpay reader is already processing a transaction");
                        } else if(error == "register_not_paired") {
                            this.presentAlert("Problem","", "The Smartpay reader has been unpaired");
                        } else if(error == "service_unavailable") {
                            this.presentAlert("Problem", "", "Service unavailable");
                        }
                    });
                }).catch(error => {
                    this.presentAlert("Problem", "", "Failed to connect to Smartpay");
                });
                
            }
        }
        else {

            this.presentSpinner('Adding payment').then(() => {
                this.orderService.addOrderPayment(this.order.id, this.params).then(async () => {
                    await this.spinner.dismiss();
                    await this.modalController.dismiss();
                })
                .catch(() => {
                    this.spinner.dismiss();
                });
            });
            
        }
    }

    loadSettings() {
        return new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.storageService.get("connected_account_id").then(connected_account_id => {
					if (connected_account_id) {
						this.connectedAccountService.getConnectedAccount(connected_account_id).then(connected_account => {
                            if (connected_account) {
                                this.apiService.getSettings(connected_account).then((settings: {}) => {
                                    if(settings) {
                                        this.settings = settings;
                                    }
                                    resolve();
                                })
                                .catch((error) => {
                                    if(error.status === 400) {
                                        this.presentAlert('Problem', 'Unknown error', "Unfortunately something went wrong when trying to retrieve the settings.");
                                    }
                                    else if(error.status == 403) {
                                        this.presentAlert('Problem', 'Insufficient permissions', "You don't have permission to view settings.");
                                    }
                                    else if(error.status === 404 || error.status === 0) {
                                        this.presentAlert('Problem', 'Unavailable', "Unfortunately we're unable to retrieve settings at this time.");
                                    }
                                    reject();
                                });
                            } 
                            else {
                                reject();
                            }
                        })
                        .catch(error => {
                            reject(error);
                        });
					} 
                    else {
						reject();
					}
				})
				.catch(error => {
					reject(error);
				});                
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    async presentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: this.params['date'],
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.params['date'] = data.data['date'];
                    this.formatted_date = this.moment(this.params['date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }
    
}
